import FlagIcon from "app/components/Icons/FlagIcon";
import CustomTooltip from "app/components/Tooltip";
import CommonPrioritySelection from "app/containers/Features/components/CommonPrioritySelection";
import React, { FC } from "react";

import { priorityOptions } from "../../data";
import { PriorityFilterEnum } from "app/types";

interface CustomProps {
  value: string;
  setValue: (val: string) => void;
  onOpen: () => void;
  onClose: () => void;
}
export const PriorityButton: FC<CustomProps> = ({
  value,
  setValue,
  onClose,
  onOpen,
}) => {
  const selectedOptions = priorityOptions.find((p) => p.value === value);

  return (
    <CommonPrioritySelection
      trigger={
        <button className="flex items-center justify-center w-[28px] h-[28px] px-[6px] rounded-[4px] border border-[#E9ECF2] text-xs leading-[18px] font-medium text-secondary hover:bg-[#ECEEF2]  hover:border-[#E9ECF2] rounded-[4px] data-[state=open]:border-[#79808A] data-[state=open]:outline-[#79808A] data-[state=open]:border-[1px] min-w-max   ">
          <CustomTooltip
            text="Set priority"
            className="flex items-center gap-1"
            position="bottom"
          >
            {selectedOptions ? (
              <div className="flex items-center gap-1 w-full">
                <FlagIcon size={16} color={selectedOptions.color} />
                <span className={`text-sm font-normal text-secondary `}>
                  {selectedOptions.label}
                </span>
              </div>
            ) : (
              <FlagIcon />
            )}
          </CustomTooltip>
        </button>
      }
      align="center"
      setValue={(val) => {
        setValue(val);
      }}
      value={value as PriorityFilterEnum}
      isHeader="priorities"
      className="min-w-[237px] py-2"
      onOpen={onOpen}
      onClose={onClose}
    />
  );
};
